import {Space} from "antd";
import {useCreateSubscriptionContext} from "../../context/create-subscription";
import {CreateSubscriptionBasicFormStep} from "../basic-form";
import {CreateSubscriptionCheckoutFormStep} from "../checkout-form";
import {CreateSubscriptionCoverImagesUploadStep} from "../cover-images-upload";
import {CreateSubscriptionFormStepsMobile} from "../create-subscription-steps";
import {StyledHideStepOnDesktop} from "../../../../../components/offering-form/general/steps/styles";
import {CreateSubscriptionAutomationsStep} from "../automations";
import {DraftResumeBanner} from "../../../../../components/offering-form/general/draft-resume-banner";
import {useDraftResumeBanner} from "../../../../../utils/offering-create-draft";

export function CreateSubscriptionMultiStepForm() {
  const {
    dispatch,
    wasDraftRestored,
    state: {currentCreateSubscriptionStep},
  } = useCreateSubscriptionContext();
  const {formKey, showBanner, handleStartFresh} = useDraftResumeBanner(
    wasDraftRestored,
    dispatch
  );

  return (
    <Space size={16} direction="vertical" style={{display: "flex"}}>
      {showBanner ? <DraftResumeBanner onStartFresh={handleStartFresh} /> : null}
      <StyledHideStepOnDesktop>
        <CreateSubscriptionFormStepsMobile />
      </StyledHideStepOnDesktop>
      <div key={formKey}>
        {currentCreateSubscriptionStep === "basicForm" ? (
          <CreateSubscriptionBasicFormStep />
        ) : currentCreateSubscriptionStep === "coverImagesUpload" ? (
          <CreateSubscriptionCoverImagesUploadStep />
        ) : currentCreateSubscriptionStep === "automations" ? (
          <CreateSubscriptionAutomationsStep />
        ) : currentCreateSubscriptionStep === "checkoutForm" ? (
          <CreateSubscriptionCheckoutFormStep />
        ) : null}
      </div>
    </Space>
  );
}
